export default __webpack_public_path__ + "static/media/ODDZ-BNB.89205af4.svg";